<template>
    <sections>
        <app-subheader title="Live Stream" :parent="{title: 'Home', route: '/'}" :dark="true">
            <button-subheader
                v-if="isAdmin && stream"
                buttonIcon="edit"
                buttonText="Edit"
                :buttonHref="$config.public.admin.stream + stream.id_stream"
                :dark="true"
            ></button-subheader>
        </app-subheader>
        <section-stream-embed
            v-if="!loading"
            :stream="stream"
            :overlayNow="chapterNow?.stream_chapter_title"
            :overlayNext="chapterNext?.stream_chapter_title"
            @refresh="refreshStream"
        ></section-stream-embed>
        <section-stream-description
            v-if="!loading"
            :stream="stream"
            :chaptersByDay="chaptersByDay"
            :error="error"
        ></section-stream-description>
        <loading-spinner v-if="loading"></loading-spinner>
    </sections>
</template>

<script setup>
const streamSlug = useRoute().params.streamSlug;

const {isAdmin} = storeToRefs(useStoreAuth());

const {error, stream, chaptersByDay, chapterNow, chapterNext} = storeToRefs(useStoreStream());
const {getStream, getChapters, stopChapters, refreshStream} = useStoreStream();

const {getStreams} = useStoreStreams();

await useLazyAsyncData('getStream' + streamSlug, () => getStream(streamSlug).then(() => true));

const loading = computed(() => {
    if (stream.value?.stream_external_url) return true;
    return stream.value === null && !error.value;
});

watch(
    stream,
    async () => {
        if (stream.value?.stream_external_url) {
            await navigateTo(stream.value.stream_external_url, {
                replace: true,
                external: true,
            });
        }
    },
    {immediate: true},
);

onMounted(() => {
    getChapters(streamSlug);
    getStreams();
});

onUnmounted(() => {
    stopChapters();
});

useSeoStream().buildReactiveHead(stream, error);
</script>
